'use strict';

function RichTextBlock() {
  $("table").wrap('<div class="table-outer"></div>').wrap('<div class="table-wrapper"></div>');
  $("table").each(function () {
    $(this).css('border-spacing', $(this).attr('cellspacing') + "px");
    $(this).find('td').css('padding', $(this).attr('cellspacing') + "px");
    $(this).find('th').css('padding', $(this).attr('cellspacing') + "px");
    if ($(this).width() > $(this).parent().width()) {
      $(this).parent().parent().addClass('responsive-table');
    }
  });
  $('.table-outer .table-wrapper').scroll(function () {
    var $amount_to_scroll = $(this).find('table').width() - $(this).width();
    var $amount_scrolled = $(this).scrollLeft();
    if ($amount_scrolled > 0 + 5) {
      $(this).parent().addClass('left-beginning');
    } else {
      $(this).parent().removeClass('left-beginning');
    }
    if ($amount_scrolled + 5 > $amount_to_scroll) {
      $(this).parent().addClass('reached-end');
    } else {
      $(this).parent().removeClass('reached-end');
    }
  });
}

export default RichTextBlock;
